import BustleLogoImg from 'assets/images/reviews/reviews-Bustle-Logo.png';
import ByrdieImg from 'assets/images/reviews/reviews-Byrdie-Logo.png';
import CosmopolitanImg from 'assets/images/reviews/reviews-Cosmo-Logo.png';
import ElleImg from 'assets/images/reviews/reviews-elle-Logo.png';
import GlamourImg from 'assets/images/reviews/reviews-Glamour-Logo.png';
import HousekeepingImg from 'assets/images/reviews/reviews-Good-Housekeeping-Logo.png';
import BazaarImg from 'assets/images/reviews/reviews-HarperBazaar-Logo.png';
import InStyleImg from 'assets/images/reviews/reviews-InStyle-Logo.png';
import PureWowImg from 'assets/images/reviews/reviews-PureWow-Logo.png';
import RealSimpleImg from 'assets/images/reviews/reviews-Real-Simple-Logo.png';
import RefineryImg from 'assets/images/reviews/reviews-Refinery29-Logo.png';
import WomensHealthImg from 'assets/images/reviews/reviews-Womens-Health-Logo.png';

export const featuredMagazine1 = {
  imgAlt: 'Bustle',
  imgSrc: BustleLogoImg,
  link: '',
};

export const featuredMagazine2 = {
  imgAlt: 'Byrdie',
  imgSrc: ByrdieImg,
  link: '',
};

export const featuredMagazine3 = {
  imgAlt: 'Cosmopolitan',
  imgSrc: CosmopolitanImg,
  link: '',
};
export const featuredMagazine4 = {
  imgAlt: 'Elle',
  imgSrc: ElleImg,
  link: '',
};

export const featuredMagazine5 = {
  imgAlt: 'Glamour',
  imgSrc: GlamourImg,
  link: '',
};

export const featuredMagazine6 = {
  imgAlt: 'Good Housekeeping',
  imgSrc: HousekeepingImg,
  link: '',
};
export const featuredMagazine7 = {
  imgAlt: 'Harper’s Bazaar',
  imgSrc: BazaarImg,
  link: '',
};
export const featuredMagazine8 = {
  imgAlt: 'InStyle',
  imgSrc: InStyleImg,
  link: '',
};
export const featuredMagazine9 = {
  imgAlt: 'PureWow',
  imgSrc: PureWowImg,
  link: '',
};

export const featuredMagazine10 = {
  imgAlt: 'Real Simple',
  imgSrc: RealSimpleImg,
  link: '',
};

export const featuredMagazine11 = {
  imgAlt: 'Refinery',
  imgSrc: RefineryImg,
  link: '',
};

export const featuredMagazine12 = {
  imgAlt: 'Womens Health',
  imgSrc: WomensHealthImg,
  link: '',
};
export const featuredMagazineLogos = [
  featuredMagazine1,
  featuredMagazine2,
  featuredMagazine3,
  featuredMagazine4,
  featuredMagazine5,
  featuredMagazine6,
  featuredMagazine7,
  featuredMagazine8,
  featuredMagazine9,
  featuredMagazine10,
  featuredMagazine11,
  featuredMagazine12,
];
